import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";
import { api, apiErrorMessage, formatDate } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export function CommentSection({ articleId }) {
  const { user } = useAuth();
  const [comments, setComments] = useState([]);
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(false);

  const load = async () => {
    const { data } = await api.get("/comments", { params: { article_id: articleId } });
    setComments(data);
  };

  useEffect(() => {
    if (articleId) load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [articleId]);

  const submit = async (e) => {
    e.preventDefault();
    if (!content.trim()) return;
    setLoading(true);
    try {
      await api.post("/comments", { article_id: articleId, content });
      setContent("");
      toast.success("Коментарът е изпратен и очаква одобрение от редакцията.");
    } catch (err) {
      toast.error(apiErrorMessage(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="mt-16" data-testid="comment-section">
      <h3 className="font-serif text-2xl font-bold text-[#10243A] mb-6">Коментари ({comments.length})</h3>

      {user ? (
        <form onSubmit={submit} className="mb-8 space-y-3">
          <Textarea
            placeholder="Споделете мнението си..."
            value={content}
            onChange={(e) => setContent(e.target.value)}
            data-testid="comment-textarea"
            className="min-h-[100px]"
          />
          <Button type="submit" disabled={loading} className="bg-[#10243A] hover:bg-[#C47A35] transition-colors" data-testid="comment-submit-btn">
            {loading ? "Изпращане..." : "Коментирай"}
          </Button>
        </form>
      ) : (
        <p className="mb-8 text-sm text-[#66717B]" data-testid="comment-login-prompt">
          <Link to="/login" className="text-[#A6631F] font-semibold underline">Влезте</Link> в профила си, за да коментирате.
        </p>
      )}

      <div className="space-y-6">
        {comments.length === 0 && <p className="text-sm text-[#66717B]">Все още няма коментари. Бъдете първи.</p>}
        {comments.map((c) => (
          <div key={c.id} className="border-b border-[#E4E7E9] pb-4" data-testid={`comment-${c.id}`}>
            <div className="flex items-center gap-2 text-sm">
              <span className="font-semibold text-[#10243A]">{c.user_name}</span>
              <span className="text-[#66717B]">&middot; {formatDate(c.created_at)}</span>
              {c.parent_id && <span className="text-xs text-[#C47A35]">в отговор</span>}
            </div>
            <p className="mt-1 text-[#20252B]">{c.content}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
